// @ts-nocheck

import React from 'react';

import { vehiclePlanStatus } from '../../lib/enum';

import AutoGeneratedEnumSelect from './AutoGeneratedEnumSelect';




export default ({ exclude, ...props }) => {
  let autoType = {};
  if (Array.isArray(exclude)) {
    Object.keys(vehiclePlanStatus).forEach((status) => {
      if (!exclude.includes(status)) {
        autoType[status] = vehiclePlanStatus[status];
      }
    });
  } else {
    autoType = { ...vehiclePlanStatus };
  }
  const Select = AutoGeneratedEnumSelect({
    placeholder: 'Выберите статус',
    autoType
  });
  return <Select {...props} />;
};
